import { IProfileDto } from 'api/api';
import actionCreatorFactory from 'typescript-fsa';
import { constants } from './constants';

const actionCreator = actionCreatorFactory('profile');

export const getProfileAction = actionCreator<{ profile: IProfileDto }>(constants.GET_PROFILE);
export const updateProfileAction = actionCreator.async<IProfileDto, IProfileDto>(constants.UPDATE_PROFILE);
